module.exports = __webpack_public_path__ + "img/download.66b9717.png";